function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "menu-home",
  "data-name": "Path 3481",
  d: "M9.157,20.771V17.7a1.426,1.426,0,0,1,1.424-1.419h2.886A1.426,1.426,0,0,1,14.9,17.7h0v3.076A1.225,1.225,0,0,0,16.1,22h1.924A3.456,3.456,0,0,0,21.5,18.562h0V9.838a2.439,2.439,0,0,0-.962-1.9l-6.58-5.248a3.18,3.18,0,0,0-3.944,0L3.462,7.943a2.42,2.42,0,0,0-.962,1.9v8.714A3.456,3.456,0,0,0,5.973,22H7.9a1.235,1.235,0,0,0,1.241-1.229h0",
  transform: "translate(-1.75 -1.132)",
  fill: "none",
  stroke: "#505e6c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgMenuHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 21.618,
    viewBox: "0 0 20.5 21.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHome);
export default __webpack_public_path__ + "static/media/menu-home.088547d3.svg";
export { ForwardRef as ReactComponent };